/*
 * Created on Mon Mar 03 2025
 * Author lixiao
 * Filename: apis/device/index.js
 * Copyright (c) 2025 lixiao
 */

import {
    generateFlatApi
} from "webasercomps/src/apis/utils"

const {fetch, create, modify} = generateFlatApi({
    fetchURL: '/v3/nassets/device/fetch/all',
    createURL: '/v3/nassets/device/create',
    modifyURL: '/v3/nassets/device/modify',
    recordProcessor: function(result, oper){
        try{
            if(oper === 'fetch'){
                result = result.map(item => {
                    item.device.data = JSON.parse(item.device.data);
                    return item;
                });
            }
        }catch(e){
            console.error('recordProcessor error:', e);
        }
        
        return result;
    }
});

export {
    fetch, create, modify
}

export const eps = {
    FETCH_DEVICES: '/nassets/device/fetch',
    CREATE_DEVICE: '/nassets/device/create',
    MODIFY_DEVICE: '/nassets/device/modify'
}